// JWT token store backed by localStorage.
//
// SECURITY NOTE (accepted for this slice): tokens live in localStorage, which is
// readable by any JS on the page → vulnerable to XSS token theft. This is a
// deliberate trade-off for the first internal-only support slice; the future
// candidate is httpOnly refresh cookies (see optimization.md). Keep this isolated
// here so swapping the storage backend later is a one-file change.

const ACCESS_KEY = "nsd.access";
const REFRESH_KEY = "nsd.refresh";

// Optional in-process hook so the auth store can react to a forced logout
// (e.g. refresh failed inside the axios interceptor).
let onLogout: (() => void) | null = null;

export const tokenStore = {
  getAccess(): string | null {
    return localStorage.getItem(ACCESS_KEY);
  },
  getRefresh(): string | null {
    return localStorage.getItem(REFRESH_KEY);
  },
  setTokens(access: string, refresh: string): void {
    localStorage.setItem(ACCESS_KEY, access);
    localStorage.setItem(REFRESH_KEY, refresh);
  },
  setAccess(access: string): void {
    localStorage.setItem(ACCESS_KEY, access);
  },
  clear(): void {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
  },
  hasTokens(): boolean {
    return Boolean(localStorage.getItem(ACCESS_KEY));
  },
  // Registered by the auth store so the interceptor can trigger logout on hard refresh failure.
  registerLogout(fn: () => void): void {
    onLogout = fn;
  },
  triggerLogout(): void {
    this.clear();
    onLogout?.();
  },
};
